import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconButtonComponent, RtTooltip } from '@core/user-interface-legacy';

const DRAG_CLICK_THRESHOLD = 5;

@Component({
  selector: 'rt-evaluation-panel-header',
  templateUrl: './evaluation-panel-header.component.html',
  styleUrls: ['./evaluation-panel-header.component.less'],
  host: {
    '[class.fullscreen-mode]': 'isFullScreenMode()',
    '(pointerdown)': 'onPointerDown($event)',
    '(click)': 'onHeaderClick($event)',
  },
  imports: [IconButtonComponent, TranslatePipe, RtTooltip],
})
export class EvaluationPanelHeaderComponent {
  protected readonly title = input<string>('');
  protected readonly isExpanded = input<boolean>(true);
  protected readonly isFullScreenMode = input<boolean>(false);

  public readonly expand = output<void>();
  public readonly fullscreen = output<void>();
  public readonly close = output<void>();

  private pointerDownPosition: { x: number; y: number } | null = null;

  protected onPointerDown(event: PointerEvent): void {
    this.pointerDownPosition = { x: event.clientX, y: event.clientY };
  }

  protected onHeaderClick(event: MouseEvent): void {
    if (this.isExpanded() || this.isDragGesture(event)) {
      return;
    }

    this.expand.emit();
  }

  private isDragGesture(event: MouseEvent): boolean {
    const start = this.pointerDownPosition;
    this.pointerDownPosition = null;

    if (!start) {
      return false;
    }

    const movedX = Math.abs(event.clientX - start.x);
    const movedY = Math.abs(event.clientY - start.y);

    return movedX > DRAG_CLICK_THRESHOLD || movedY > DRAG_CLICK_THRESHOLD;
  }
}
